(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			const autoplay =
				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
			const slideshowSwiper = new Swiper(slideshow, {
				navigation: {
  nextEl: slideshow.querySelector(".swiper-button-next"),
  prevEl: slideshow.querySelector(".swiper-button-prev"),
},
pagination: {
  el: slideshow.querySelector(".swiper-pagination"),
  clickable: true,
},
				loop: true,
autoHeight: false,
allowTouchMove: true,
autoplay: autoplay ? {
  delay: 5000,
  disableOnInteraction: false,
  pauseOnMouseEnter: false
} : false,
			});
			
			if (slideshowSwiper.slides.length < 2) {
				slideshowSwiper.allowTouchMove = false;
			} else {
				slideshowSwiper.allowTouchMove = true;
			}
			if (slideshowSwiper.slides.length > 1)
				slideshow.classList.add("slideshow__swiper--multiple-slides");
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
